import { atom } from 'recoil';

import { FilterModalTypes } from '../../../components/FilterModal';

export const investmentStrategyFilterPositiveAtom = atom<FilterModalTypes.FilterAtom>({
  key: 'investmentStrategyFilterPositiveState',
  default: {
    availableFilters: [],
    selectedFilters: [],
    appliedFilters: [],
  },
});

export const investmentStrategyFilterDiversifierAtom = atom<FilterModalTypes.FilterAtom>({
  key: 'investmentStrategyFilterDiversifierState',
  default: {
    availableFilters: [],
    selectedFilters: [],
    appliedFilters: [],
  },
});
